"use strict";
/**
 * Parallel Markets Service
 *
 * Persists order-page parallel market selections per primary market.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PARALLEL_VENUE_TAGS = void 0;
exports.getParallelMarkets = getParallelMarkets;
exports.addParallelMarkets = addParallelMarkets;
exports.removeParallelMarket = removeParallelMarket;
exports.legSideLabels = legSideLabels;
exports.setParallelMarketInvert = setParallelMarketInvert;
exports.clearParallelMarkets = clearParallelMarkets;
exports.PARALLEL_VENUE_TAGS = {
    kalshi: "Kalshi",
    "pm-us": "PM-US",
    novig: "Novig",
};
const STORAGE_KEY = "kalshi_parallel_markets";
function loadFromStorage() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) {
            return { byPrimaryMarket: {} };
        }
        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== "object") {
            return { byPrimaryMarket: {} };
        }
        return {
            byPrimaryMarket: parsed.byPrimaryMarket &&
                typeof parsed.byPrimaryMarket === "object"
                ? parsed.byPrimaryMarket
                : {},
        };
    }
    catch {
        return { byPrimaryMarket: {} };
    }
}
function saveToStorage(data) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}
function isSameSelection(left, right) {
    return left.marketId === right.marketId && left.venue === right.venue;
}
function getParallelMarkets(primaryMarketId) {
    if (!primaryMarketId) {
        return [];
    }
    const stored = loadFromStorage();
    return stored.byPrimaryMarket[primaryMarketId] ?? [];
}
function addParallelMarkets(primaryMarketId, selections) {
    const stored = loadFromStorage();
    const existing = stored.byPrimaryMarket[primaryMarketId] ?? [];
    const deduped = [...existing];
    for (const selection of selections) {
        if (!deduped.some((current) => isSameSelection(current, selection))) {
            deduped.push(selection);
        }
    }
    stored.byPrimaryMarket[primaryMarketId] = deduped;
    saveToStorage(stored);
    return deduped;
}
function removeParallelMarket(primaryMarketId, marketId, venue) {
    const stored = loadFromStorage();
    const nextSelections = (stored.byPrimaryMarket[primaryMarketId] ?? []).filter((selection) => selection.marketId !== marketId || selection.venue !== venue);
    if (nextSelections.length === 0) {
        delete stored.byPrimaryMarket[primaryMarketId];
    }
    else {
        stored.byPrimaryMarket[primaryMarketId] = nextSelections;
    }
    saveToStorage(stored);
    return nextSelections;
}
/**
 * The side toggle's two labels, [YES, NO]. A Kalshi binary names one team on
 * both sides, so those read "YES · Pittsburgh" / "NO · Pittsburgh".
 */
function legSideLabels(names) {
    const [yes, no] = (names ?? ["", ""]).map((n) => n.trim());
    if (yes && no && yes !== no)
        return [yes, no];
    const name = yes || no;
    return name ? [`YES · ${name}`, `NO · ${name}`] : ["YES", "NO"];
}
/** Record which of a leg's sides the click's YES buys. */
function setParallelMarketInvert(primaryMarketId, marketId, venue, invert) {
    const stored = loadFromStorage();
    const next = (stored.byPrimaryMarket[primaryMarketId] ?? []).map((selection) => selection.marketId === marketId && selection.venue === venue ? { ...selection, invert } : selection);
    stored.byPrimaryMarket[primaryMarketId] = next;
    saveToStorage(stored);
    return next;
}
function clearParallelMarkets(primaryMarketId) {
    const stored = loadFromStorage();
    delete stored.byPrimaryMarket[primaryMarketId];
    saveToStorage(stored);
}
